<template>
  <BaseDialog centered contentClass="task-stuck" ref="dialog" :show-actions="true" @closeModal="closeDialog">
    <template slot="title">{{ $t('aloha-extension.task-stuck.title') }}</template>
    <template slot="content">
      <div class="task-stuck-dialog">
        <div class="task-stuck-dialog__section">
          <BaseIcon name="alert-circle" class="task-stuck-dialog__icon is-error" />
          <div class="task-stuck-dialog__message">
            <p class="task-stuck-dialog__description">
              {{ $t('aloha-extension.task-stuck.description') }}
            </p>
            <p v-if="stepLabel" class="task-stuck-dialog__step">
              {{ $t('aloha-extension.task-stuck.step', { stepName: stepLabel }) }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <template slot="actions">
      <div class="task-stuck-dialog__actions">
        <BaseButton @click.native="closeDialog">{{ $t('actions.close') }}</BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'ChromeExtensionStuckDialog',
  components: {
    BaseButton,
    BaseDialog,
    BaseIcon,
  },
  data() {
    return {
      stepName: '',
    };
  },
  computed: {
    stepLabel() {
      if (!this.stepName) return '';
      const key = `aloha-extension.task-stuck.steps.${this.stepName}`;
      // The extension releases on its own cycle and can report a step this version has no
      // translation for; show the raw step name rather than the untranslated key path.
      return this.$te(key) ? this.$t(key) : this.stepName;
    },
  },
  methods: {
    openDialog({ stepName }) {
      this.stepName = stepName;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__task-stuck {
  height: auto;
  max-height: 80vh !important;
  width: 50%;
  min-width: 400px;
  max-width: 600px;
  position: relative;
  border-radius: $border-radius-root;

  .base-dialog__content {
    padding: 0;
  }

  .base-dialog__actions {
    padding: 16px 32px;
    background: transparent;
  }
}

.task-stuck-dialog {
  padding: 0 32px 16px;

  &__section {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px 0;
  }

  &__icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-top: 2px;

    &.is-error {
      color: $color-error;
    }
  }

  &__message {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__description {
    font-size: $font-size-small;
    color: $color-normal;
    margin: 0;
  }

  &__step {
    font-size: $font-size-small;
    font-weight: 600;
    color: $color-normal;
    margin: 0;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
